export default {
  createSocialPostRequest: false,
  createSocialPostSuccess: false,
  createSocialPostFailed: false,
  createSocialPostErrors: null,

  deleteScheduledMessageRequest: false,
  deleteScheduledMessageSuccess: false,
  deleteScheduledMessageFailed: false,
  deleteScheduledMessageErrors: null,

  updateScheduledMessageRequest: false,
  updateScheduledMessageSuccess: false,
  updateScheduledMessageFailed: false,
  updateScheduledMessageErrors: null,

  getScheduledMessagesRequest: false,
  getScheduledMessagesSuccess: false,
  getScheduledMessagesFailed: false,
  getScheduledMessagesErrors: null,
  scheduledMessages: [],

  isEditing: false,
  post: null,

  /* facebook insights */

  facebookPages: [],

  selectedFacebookPage: null,

  /* Instagram Insights */
  instagramPages: [],
  selectedInstagramPage: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/social/state.js